import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar';

function ProductoAnadido() {
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    // Trackear conversión de producto añadido
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-970875118/producto_anadido',
        value: 1.0,
        currency: 'EUR'
      });
    }

    // Countdown y redirección automática
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          // Se avisa a la home de que se viene de añadir un producto: es ahí,
          // en una página que no se va sola, donde se sugiere el botón de
          // navegador para la próxima vez.
          navigate('/', { state: { productoAnadido: true } });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div style={{ padding: 20 }}>
      <Navbar />
      <div style={{ 
        textAlign: 'center', 
        maxWidth: '600px', 
        margin: '50px auto',
        padding: '30px',
        backgroundColor: '#f8f9fa',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ color: '#28a745', marginBottom: '20px' }}>
          ✅ ¡Producto añadido!
        </h1>
        <p style={{ fontSize: '1.1em', marginBottom: '20px' }}>
          Tu producto se ha añadido correctamente. Te avisaremos cuando baje de precio.
        </p>
        <p style={{ fontSize: '0.9em', color: '#666', marginBottom: '20px' }}>
          Redirigiendo en {countdown} segundos...
        </p>
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            navigate('/', { state: { productoAnadido: true } });
          }}
          style={{
            display: 'inline-block',
            padding: '12px 24px',
            backgroundColor: '#007bff',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '5px',
            fontWeight: 'bold'
          }}
        >
          Ver mis productos
        </a>
      </div>
    </div>
  );
}

export default ProductoAnadido;